/* -----------------Child components--------------- */
import { CustomAppbar } from "components/index";

import { pageViewTypes } from "@constants/tracking";
/* -----------------Types--------------- */
import { AccountSettings } from "@features/account";
import useAnalytics from "@hooks/useAnalytics";
import { useDevice } from "@memorang/ui";
import DocumentTitle from "components/DocumentTitle";
/* -----------------Globals--------------- */
import { Stack } from "expo-router";
import { useTranslation } from "react-i18next";
const AccountSettingsRoute = () => {
	const { isMobile } = useDevice();

	const { t } = useTranslation();

	useAnalytics({
		type: pageViewTypes.settings,
	});

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: true,
					header: () => (
						<CustomAppbar
							options={{
								headerTitle: t("account.title"),
								subtitle: isMobile ? "" : t("account.subtitle"),
								headerRight: () => null,
							}}
							back
						/>
					),
				}}
			/>
			<DocumentTitle title="Account settings" />
			<AccountSettings />
		</>
	);
};

export default AccountSettingsRoute;
